import { FC } from 'react'

import { Button, ButtonSizes, ButtonVariants } from '@inno-ui/button'
import {
  ArrowCirclePathRightIcon,
  ArrowDownLeftAndUpRightIcon,
  ArrowUpRightAndDownLeftIcon,
  ClipboardLineIcon,
  MinusIcon,
  MultiplyIcon
} from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'

import { ControlButton } from '../ControlButton'
import styles from './WindowControls.module.scss'
import { WindowControlsProps } from './WindowControls.types'
import { useWindowUrl } from './useWindowUrl'

export const WindowControls: FC<WindowControlsProps> = ({
  window,
  isDesktop,
  onMinimize,
  onMaximize,
  onReload,
  onClose
}) => {
  const { t } = useTranslation()

  const windowUrl = useWindowUrl(window.id)

  const copyWindowURL = () => {
    if (!windowUrl) return

    navigator.clipboard.writeText(windowUrl)
  }

  return (
    <div className={styles.windowControls}>
      {windowUrl && (
        <Button
          variant={ButtonVariants.Text}
          label={t('window_controls.copy_window_url')}
          onClick={copyWindowURL}
          icon={ClipboardLineIcon}
          size={ButtonSizes.S}
        />
      )}

      <ControlButton onClick={onReload} icon={ArrowCirclePathRightIcon} />

      {window.canMinimize && (
        <ControlButton onClick={onMinimize} icon={MinusIcon} />
      )}

      {window.canMaximize && isDesktop && (
        <ControlButton
          onClick={onMaximize}
          icon={
            window.isMaximized
              ? ArrowUpRightAndDownLeftIcon
              : ArrowDownLeftAndUpRightIcon
          }
        />
      )}

      {/* {window.isMaximized && windowUrl && (
        <a
          href={windowUrl}
          className={styles.externalLink}
          target='_blank'
          rel='noopener noreferrer'
        >
          <ControlButton icon={ArrowUpRectangleLineIcon} />
        </a>
      )} */}
      <ControlButton onClick={onClose} icon={MultiplyIcon} />
    </div>
  )
}
